import { Injectable } from '@angular/core';

import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { NEVER, Observable } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { GlobalSettingsService } from '../services/ui/global-settings.service';
import { BinderWizardService } from '../services/sections/binder/binder-wizard.service';
import { BinderWizardDetails } from '../models/binder/binder-wizard-details.model';

@Injectable({
	providedIn: 'root'
})
export class BinderWizardDetailsResolver implements Resolve<Observable<BinderWizardDetails>> {

	constructor(
		private router: Router,
		private binderWizardService: BinderWizardService
	) { }

	resolve(activatedRouteSnapshot: ActivatedRouteSnapshot, routerStateSnapshot: RouterStateSnapshot) {

		return this.binderWizardService
			.getBinderWizardDetails(activatedRouteSnapshot.paramMap.get('token'))
			.pipe(
				catchError(() => {
					this.router.navigate(['/404']);
					GlobalSettingsService.isSecondaryLoaderLoading = false;
					return NEVER;
				})
			);
	}
}
